/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RoomFeatureDTO = {
    HYPOXI_GERAETE: 'HYPOXI_GERAETE',
    KOSMETIKLIEGE: 'KOSMETIKLIEGE',
    MASSAGELIEGEN: 'MASSAGELIEGEN',
    BALKON: 'BALKON',
    BADEWANNE: 'BADEWANNE',
    DAMPFBAD: 'DAMPFBAD',
    DUSCHE: 'DUSCHE',
    DUSCHE_INKL_STEAM_BATH: 'DUSCHE_INKL_STEAM_BATH',
    FINNISCHE_SAUNA: 'FINNISCHE_SAUNA',
    HOT_STONE_OFEN: 'HOT_STONE_OFEN',
    HOT_STONE_OFEN_MOBIL: 'HOT_STONE_OFEN_MOBIL',
    HYPOXI_GERAET: 'HYPOXI_GERAET',
    INDOOR_CYCLING_BIKES: 'INDOOR_CYCLING_BIKES',
    KEINE_ANWENDUNGEN: 'KEINE_ANWENDUNGEN',
    KEINE_BEHANDLUNGSLIEGE: 'KEINE_BEHANDLUNGSLIEGE',
    LOCKER: 'LOCKER',
    MANIKUERE: 'MANIKUERE',
    MANIKUERE_IM_FRISEUR: 'MANIKUERE_IM_FRISEUR',
    MASSAGELIEGE: 'MASSAGELIEGE',
    PEDIKUERE: 'PEDIKUERE',
    RAUM_FUER_SPA_WORKSHOPS: 'RAUM_FUER_SPA_WORKSHOPS',
    SHIATSU_MATTE: 'SHIATSU_MATTE',
    SOFTPACK: 'SOFTPACK',
    SPORT_FUER_STOFFWECHSELMESSUNGEN: 'SPORT_FUER_STOFFWECHSELMESSUNGEN',
    STORAGE: 'STORAGE',
    WASSERBETT: 'WASSERBETT',
    WHIRLWANNE: 'WHIRLWANNE'
} as const;
export type RoomFeatureDTO = typeof RoomFeatureDTO[keyof typeof RoomFeatureDTO];

